module.exports = __webpack_public_path__ + "img/img_025@2x.bdd6c660.png";